import React, {Component} from "react";
import { observer } from "mobx-react";

@observer
class WoodilveryChangeView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerWooriChangeView?' layer_open':'')}>
                <div className="bg"/>
                <div className="layer_content">
                    <div className="article_order_delivery">
                        <div className="section_tit_comm">
                            <h1>우딜 콜 자동전환 설정</h1>
                        </div>
                        <div className="section_content">
                            <div className="wrap_rider_tit">
                                <h2 className="tit">
                                    <div><strong>30분 동안</strong> 라이더 배차 지연시,</div>
                                    <div><strong>콜이 자동전환될 업체</strong>를 선택해 주세요.</div>
                                </h2>
                            </div>
                            <div className="wrap_agency">
                                <div className="wrap_rider_list">
                                    <div className="inner">
                                        <ul className="list">
                                            <li>
                                                <button>
                                                    <span className="name mutiline">생각대로</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button>
                                                    <span className="name mutiline">생각대로</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button>
                                                    <span className="name mutiline">생각대로</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="prev">
                                        <button><span></span></button>
                                    </div>
                                    <div className="next">
                                        <button><span></span></button>
                                    </div>
                                </div>
                                <div className="wrap_full_btn">
                                    <span className="f_l"><button className="btn_cancel">취소</button></span>
                                    <span className="f_r"><button className="btn_submit">설정완료</button></span>
                                </div>
                            </div>
                            {/* // 라이더 선택 자체시 */}
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => layerStore.setLayerWooriChange(false) }
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WoodilveryChangeView;